/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PdfDownloadResponse } from './PdfDownloadResponse';
import {
    PdfDownloadResponseFromJSON,
    PdfDownloadResponseFromJSONTyped,
    PdfDownloadResponseToJSON,
} from './PdfDownloadResponse';

/**
 * 
 * @export
 * @interface PdfDownloader200Response
 */
export interface PdfDownloader200Response {
    /**
     * 
     * @type {PdfDownloadResponse}
     * @memberof PdfDownloader200Response
     */
    data?: PdfDownloadResponse;
}

/**
 * Check if a given object implements the PdfDownloader200Response interface.
 */
export function instanceOfPdfDownloader200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PdfDownloader200ResponseFromJSON(json: any): PdfDownloader200Response {
    return PdfDownloader200ResponseFromJSONTyped(json, false);
}

export function PdfDownloader200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PdfDownloader200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : PdfDownloadResponseFromJSON(json['data']),
    };
}

export function PdfDownloader200ResponseToJSON(value?: PdfDownloader200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': PdfDownloadResponseToJSON(value.data),
    };
}

